<template>
  <layout>
    <!-- <img
        class="h-11 w-auto mx-auto md:hidden my-6"
        v-if="brokerLogo"
        :src="brokerLogo"
        alt="broker logo"
      /> -->
    <h1 class="header-text text-center">Awaiting Approval...</h1>
    <p class="mb-6 text-dark-gray">
      Your onboarding packet is complete, pending the carrier's approval of your
      relationship. The carrier's authorized representatives received an email
      asking them to approve your dispatcher connection relationship.
    </p>
    <p
      v-if="companyType == 'dispatcher'"
      class="mb-6 text-dark-gray md:mb-8"
    >
      In the meantime, you can add more Carriers within your Dispatcher Portal.
      For help, please call 906-Highway or email us at service@highway.com.
    </p>
    <button-main
      v-if="['carrier', 'broker'].includes(companyType)"
      @click="$router.push('/carrier/brokers')"
    >
      Go to Carrier Portal
      <img
        class="link-icon inline"
        src="@/assets/link-icon.svg"
        alt=""
      />
    </button-main>
    <button-main
      v-if="companyType == 'dispatcher'"
      @click="$router.push('/dispatcher')"
    >
      Go to Dispatcher Portal
      <img
        class="link-icon inline"
        src="@/assets/link-icon.svg"
        alt=""
      />
    </button-main>
    <div class="absolute bottom-6 left-0 right-0 px-6 md:static md:px-0">
      <p class="mt-8 text-center text-xxs text-body-color">
        <span
          >If your request is not approved shortly, please follow up with
          representatives of the carrier or contact</span
        >
        <a
          class="text-link underline"
          href="mailto:service@highway.com"
        >
          service@highway.com
        </a>
        <span>for help.</span>
      </p>
    </div>
  </layout>
</template>

<script>
import Button from '../Button.vue';
import Layout from '../layouts/HoldingTankLayout.vue';

export default {
  name: 'Held For Carrier Approval',
  components: {
    'button-main': Button,
    Layout,
  },
  props: {
    companyType: String,
    companyName: String,
    loading: Boolean,
    failedRules: Array,
    incompleteRules: Array,
    totalRules: Number,
    rulesSyntax: Object,
    supportEmail: String,
    brokerLogo: String,
  },
};
</script>
<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}
.text-link {
  color: #e7b812;
}

.link-icon {
  position: relative;
  bottom: 1px;
}
</style>
